<template>
    <div class="home-search search-component">
        <div class="row main-search main-search--minimal">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-12 searchbar-wrapper">
                        <select class="form-control select2-selection__default" id="searchHome">
                            <option v-if="location.query" selected value="1">{{ location.query }}</option>
                        </select>

                        <search-no-js-placeholder-component></search-no-js-placeholder-component>

                    </div>
                </div>
                <error-component
                        v-if="currentLocationError"
                        :message="translate.home.currentLocationError"
                ></error-component>
            </div>

            <div class="col-md-12 main-search-options mt-3" :class="{'mt-0': currentLocationError}">
                <button class="btn btn-rebrand-primary w-full" @click="$emit('search')">{{ translate.home.search }}</button>
                <button class="d-sm-none mt-2 btn btn-rebrand-grey-outline drop-shadow w-full" @click="getCurrentLocation(true)">
                    <icon-component :icon="mapPin()" width="16px" height="16px" />
                    <span>{{ translate.home.nearbyEscorts }}</span>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import searchMixin from '../mixins/search/search-mixin';
import {mapPin} from "@/core/constants/icons";

const data = () => {
    return {
        searchVariant: 'searchHome',
        locationRadiuses: constants.search_radius,
        noDistanceOnMobile: true,
    }
};

function onLocationChange(e) {
    const result = _.get(e, 'params.data.result', {});
    const payload = this.buildLocationPayload(result);

    this.store.commit('setLocation', payload);
    if (utils.isMobile()) {
        this.$emit('search');
    }
}

function onFilterUpdated(variable, value) {
    const tmp = _.cloneDeep(this.categoryTemp);
    tmp[variable] = value;

    this.store.commit('setCategoryTemp', tmp);
}

function setSearchRadius(event) {
    const radius = _.get(event, 'target.value', '20km');
    this.store.commit('setSearchRadius', radius);
}

export default {
    data,
    mixins: [
        searchMixin,
    ],
    computed: {
        ...mapState({
            location: 'location',
            meetingLocation: state => state.category.meetingLocation,
            categoryTemp: 'categoryTemp',
            searchRadius: 'searchRadius',
            translate: 'translate',
        })
    },
    methods: {
        mapPin,
        onLocationChange,
        onFilterUpdated,
        setSearchRadius,
    }
}
</script>
